import { render, staticRenderFns } from "./PopUpMenu.vue?vue&type=template&id=5b5bd974&scoped=true&"
import script from "./PopUpMenu.vue?vue&type=script&lang=js&"
export * from "./PopUpMenu.vue?vue&type=script&lang=js&"
import style0 from "./PopUpMenu.vue?vue&type=style&index=0&id=5b5bd974&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5bd974",
  null
  
)

export default component.exports